import dayjs from 'dayjs';

import { useMemo } from 'react';

import FormHeader from 'components/global/FormHeader';
import { HeaderContainerFormHeader } from 'components/global/styled/FormHeader.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterAction, FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ENUMS, REPORT } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';
import PATHS, { mergePaths } from 'utils/paths';

import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';

const IntegratorSlaReportConfig = {
	id: DYNAMICLISTS.INTEGRATOR_SLA_REPORT,
	columns: [
		{
			Header: 'id',
			accessor: 'id',
			filterType: FilterType.number,
			width: 50,
			show: false,
			showCopyButton: true
		},
		{
			Header: 'otoOrderID',
			accessor: 'OtoOrderId',
			filterType: FilterType.string,
			width: 90,
			show: false
		},
		{
			Header: 'orderID',
			accessor: 'orderID',
			filterType: FilterType.string,
			width: 90
		},
		{
			Header: 'DCSettingName',
			accessor: 'dcSettingName',
			filterType: FilterType.string,
			width: 90
		},
		{
			Header: 'shipmentNumber',
			accessor: 'shipmentNumber',
			filterType: FilterType.string,
			width: 90
		},
		{
			Header: 'pickupCountry',
			accessor: 'pickupCountry',
			filterType: FilterType.enumMulti,
			enumName: ENUMS.COUNTRIES,
			filterPrefix: 'country.',
			renderCell: ListComponents.COUNTRY,
			width: 100,
			show: false
		},
		{
			Header: 'pickupCity',
			accessor: 'pickupCity',
			filterType: FilterType.multiSelection,
			width: 100,
			show: false
		},
		{
			Header: 'destinationCountry',
			accessor: 'destinationCountry',
			filterType: FilterType.enumMulti,
			enumName: ENUMS.COUNTRIES,
			filterPrefix: 'country.',
			renderCell: ListComponents.COUNTRY,
			width: 100,
			show: false
		},
		{
			Header: 'destinationCity',
			accessor: 'destinationCity',
			filterType: FilterType.multiSelection,
			width: 100,
			show: false
		},
		{
			Header: 'serviceType',
			accessor: 'serviceType',
			filterType: FilterType.string,
			width: 90,
			show: false
		},
		{
			Header: 'shipmentType',
			accessor: 'shipmentType',
			width: 100,
			filterType: FilterType.enumMulti,
			enumName: ENUMS.SHIPMENT_TYPE,
			show: false
		},
		{
			Header: 'status',
			accessor: 'status',
			filterType: FilterType.multiSelection,
			renderCell: ListComponents.STATUS
		},
		{
			Header: 'orderDate',
			accessor: 'orderDate',
			filterType: FilterType.date,
			width: 100,
			renderCell: ListComponents.DATETIME,
			show: false
		},
		{
			Header: 'shipmentDate',
			accessor: 'shipmentDate',
			filterType: FilterType.date,
			width: 100,
			renderCell: ListComponents.DATETIME
		},
		{
			Header: 'pickupDate',
			accessor: 'pickupDate',
			filterType: FilterType.date,
			width: 100,
			renderCell: ListComponents.DATETIME
		},
		{
			Header: 'firstAttemptDate',
			accessor: 'firstAttemptDate',
			filterType: FilterType.date,
			width: 100,
			renderCell: ListComponents.DATETIME
		},
		{
			Header: 'deliveryDate',
			accessor: 'deliveryDate',
			filterType: FilterType.date,
			width: 100,
			renderCell: ListComponents.DATETIME
		},
		{
			Header: 'returnDate',
			accessor: 'returnDate',
			filterType: FilterType.date,
			width: 100,
			renderCell: ListComponents.DATETIME,
			show: false
		},
		{
			Header: 'pickupCutoffTime',
			accessor: 'pickupCutoffTime',
			filterType: FilterType.string,
			width: 90,
			show: false
		},
		{
			Header: 'transferDuration',
			accessor: 'transferDuration',
			filterType: FilterType.string,
			width: 90,
			show: false
		},
		{
			Header: 'pickUpSLATime',
			accessor: 'pickUpSLATime',
			filterType: FilterType.date,
			width: 100,
			renderCell: ListComponents.DATETIMEWITHOUTLOCALE
		},
		{
			Header: 'deliverySLATime',
			accessor: 'deliverySLATime',
			filterType: FilterType.date,
			width: 100,
			renderCell: ListComponents.DATETIMEWITHOUTLOCALE
		},
		{
			Header: 'pickupSlaCompliance',
			accessor: 'pickupSlaCompliance',
			filterType: FilterType.enumMulti,
			enumName: ENUMS.PICKUP_SLA_COMPLIANCE,
			width: 90
		},
		{
			Header: 'deliveryAttemptSlaCompliance',
			accessor: 'deliveryAttemptSlaComply',
			filterType: FilterType.enumMulti,
			enumName: ENUMS.DELIVERY_ATTEMPT_SLA_COMPLIANCE,
			width: 90
		},
		{
			Header: 'deliveredSlaCompliance',
			accessor: 'deliveredSlaComply',
			filterType: FilterType.enumMulti,
			enumName: ENUMS.DELIVERED_SLA_COMPLIANCE,
			width: 90
		}
	],
	fetchUrl: REPORT.SLA.GET_INTEGRATOR_SLA_REPORT_LIST,
	exportName: 'integratorSlaReport',
	defaultSort: [{ id: 'id', desc: true }]
};

const SLAReport = () => {
	const defaultFilters = useMemo(
		() => [
			{
				column: {
					Header: 'shipmentDate',
					accessor: 'shipmentDate',
					filterType: FilterType.date,
					width: 100,
					renderCell: ListComponents.DATETIME
				},
				action: FilterAction.between,
				value: {
					start: dayjs().subtract(30, 'day').endOf('day').toISOString(),
					end: dayjs().endOf('day').toISOString()
				}
			}
		],
		[]
	);
	return (
		<div>
			<HeaderContainerFormHeader>
				<FormHeader
					lightTitle="reports"
					boldTitle="integratorSlaReport"
					icon={faArrowLeft}
					backUrl={mergePaths(PATHS.REPORTS, PATHS.SHIPMENT_REPORTS)}
				/>
			</HeaderContainerFormHeader>
			<DynamicList {...IntegratorSlaReportConfig} defaultFilters={defaultFilters} />
		</div>
	);
};

export default SLAReport;
